import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  module: any;
  modules: any;
  accessModules: any[] = [];

  constructor(private route : Router, private alertController:AlertController){
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    this.accessModules = []
    this.module = await route.data.module;
    console.log(this.module,'this.module')
    this.modules = await JSON.parse(sessionStorage.getItem('accessModules'))
    if(this.modules){
      await this.modules.routingModules.map((each) => {
        this.accessModules.push(each.url.replace('/', ''))    
      })

      if(this.module == 'welcome-page' && this.modules.routingModules.length < 2){
        return true
      }
      console.log(this.accessModules,'this.accessModules')
      if(this.accessModules.includes(this.module)){
        return true
      }else{
        this.presentAlert()
        this.route.navigateByUrl('/login')
        return true
      }
      
    }else{
      this.presentAlert()
      this.route.navigateByUrl('/login')
      return true
    }
    

    
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'Alert',
      subHeader: 'Access Denied',
      message: "You dont have Access to this module",
      buttons: ['OK'],
    });

    await alert.present();

  }
  
}
